import { SearchService } from './../../../core/services/search.service';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Observable, of } from 'rxjs';
import { debounceTime, distinctUntilChanged, first, startWith, switchMap } from 'rxjs/operators';

@Component({
  selector: 'app-autocomplete-input',
  templateUrl: './autocomplete-input.component.html',
  styleUrls: ['./autocomplete-input.component.scss']
})
export class AutocompleteInputComponent implements OnInit {
  @Input() label: "Setor" | "Sku" | "Nível" | "Posição" | null = null;
  @Input() placeholder = '';
  @Input() control: FormControl;
  filteredOptions: Observable<string[]>;

  constructor(private searchService: SearchService) { }

  ngOnInit(): void {
    this.filteredOptions = this.control.valueChanges.pipe(
      debounceTime(300),
      distinctUntilChanged(),
      startWith(''),
      switchMap(value => {
        if (!value || value.length <= 2) {
          return of([]);
        }
        return this._filter(value);
      })
    );
  }

  private _filter(value: string) {
    const term = value.toLowerCase();
    return this.searchService.search(this.label, term).pipe(first());
  }

}
